import { Eye, EyeOff } from 'lucide-react'
import * as React from 'react'
import { cn } from '../../lib/utils'

const PasswordInput = React.forwardRef(
  ({ className, wrapperClassName, disabled, ...props }, ref) => {
    const [visible, setVisible] = React.useState(false)

    return (
      <div className={cn('relative', wrapperClassName)}>
        <input
          type={visible ? 'text' : 'password'}
          className={cn(
            'flex h-10 w-full rounded-md border border-parch-200 bg-white py-2.5 pr-10 pl-3 text-sm text-ink-900 outline-none placeholder:text-ink-400 focus:border-green-600 focus:ring-2 focus:ring-green-600/20 disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
          ref={ref}
          disabled={disabled}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-pressed={visible}
          disabled={disabled}
          onClick={() => setVisible((current) => !current)}
          className="absolute top-1/2 right-2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-md text-ink-400 transition-colors hover:text-ink-600 disabled:pointer-events-none disabled:opacity-50"
        >
          {visible ? <EyeOff className="h-4 w-4" aria-hidden /> : <Eye className="h-4 w-4" aria-hidden />}
        </button>
      </div>
    )
  },
)
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
